// extracted by mini-css-extract-plugin
export default {"container":"CountdownCircleTimer_container__bfeCz","countdownCircle":"CountdownCircleTimer_countdownCircle__hjp2O","content":"CountdownCircleTimer_content__h7cbL"};